// conjunctions
export const API_PPDB = '/ppdb/conjunctions';
export const API_NURI = '/ppdb/conjunctions/nuri';
export const API_LPDB = '/launch-conjunction';
export const API_OAUTH = '/oauth';
export const API_FAVORITE = '/favorite';
export const API_FAVORITE_SEARCH = '/favorite/search';
export const API_FAVORITE_FIND = '/favorite/find';
export const API_AUTO_COMPLETE = '/rso-params/autocomplete';
export const API_FAVORITE_CONJUNCTIONS = '/favorite/conjunctions';
export const API_OAUTH_LOGOUT = '/oauth/logout';
export const API_TLES = '/tles';
export const API_MONTHLY_TLES = '/gps/monthly';
export const API_RSOS_OBJTYPE = '/rso-params/objtype';
export const API_RSOS = '/rso-params';
export const API_WCDB = '/watcher-catcher';
export const API_LODB = '/link-optimization';
export const API_COLADB = '/collision-avoidance';
export const API_COLADB_PPDB = '/ppdb';
export const API_LINK_AUTH = '/link-auth';
export const API_COORDINATE = '/coordinate';
export const API_CDM_CONJUNCTIONS = '/cdm/conjunctions';
export const API_MEMBER_LOGIN = '/auth/login';
export const API_MEMBER_REGISTER = '/auth/register';
export const API_MEMBER_SIMPLE_REGISTER = '/auth/simpleregisterfordemo';
export const API_GPT = '/gpt';
export const API_OPENAI_MESSAGES = '/open-ai/messages';
export const API_OPENAI_FEEDBACK = '/open-ai/feedback';
export const API_ACCESS_TOKEN_QUOTA = '/users/token/quota';
export const API_USER = '/users';
export const API_CHANGE_PASSWORD = '/auth/v1/change-password';
export const API_CHATBOT_CHAT = '/chatbot/chat';
